export async function resizeImage ({
	image, maxWidth, maxHeight, imageUrl, imageName, imageType, returnUrl, quality = 0.5,
}) {
	// create image  from file to be able to put it on canvas
	const img = await createImageFromFile({ image, imageUrl });

	// create a new canvas
	const canvas = document.createElement('canvas');

	// get image dimensions
	let { width } = img;
	let { height } = img;

	let changeRatio = 1;

	// resolve height and width
	if (width > height) {
		if (width > maxWidth) {
			changeRatio = maxWidth / width;
			height *= changeRatio;
			width = maxWidth;
		}
	}
	else {
		if (height > maxHeight) {
			changeRatio = maxHeight / height;
			width *= changeRatio;
			height = maxHeight;
		}
	}

	// change canvas size according to the resolved values
	canvas.width = width;
	canvas.height = height;

	// draw the image on the canvas and resize
	const ctx = canvas.getContext('2d');
	ctx.drawImage(img, 0, 0, width, height);
	// ctx.drawImage(canvas, 0, 0, canvas.width * changeRatio, canvas.height * changeRatio);
	// ctx.drawImage(canvas, 0, 0, canvas.width * changeRatio, canvas.height * changeRatio,
	// 	0, 0, canvas.width, canvas.height);

	// get the blob file from canvas
	const imageAsDataUrl = canvas.toDataURL(imageType || image.type, quality);

	if (returnUrl) {
		return imageAsDataUrl;
	}

	// convert to blob file and then the blob file to standard format and return
	return new File([dataURLtoBlob(imageAsDataUrl)], imageName || image.name);
}

function createImageFromFile ({ image, imageUrl }) {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.onload = () => resolve(img);
		img.onerror = reject;

		if (imageUrl) {
			img.src = imageUrl;
		}
		else {
			img.src = URL.createObjectURL(image);
		}
	});
}

function dataURLtoBlob (dataurl) {
	const arr = dataurl.split(',');
	const mime = arr[0]?.match(/:(.*?);/)?.[1];
	const bstr = atob(arr[1]);
	let n = bstr.length;
	const u8arr = new Uint8Array(n);

	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}

	return new Blob([u8arr], { type: mime });
}
